import React, { useState, useEffect } from 'react'
import { Box, Text } from "grommet"
import AgDataTable from '../../common/AgDataTable'
import { deepClone } from '../../../utils/clone'


const HealthStatusServiceOptionsApp = ({ data }) => {

    const tab_col = [
        {
            field: "user_id",
            headerName: "User Id",
            minWidth: 150,
            suppressSizeToFit: true,
        },
        {
            field: "socket_id",
            headerName: "Socket Id",
            minWidth: 300,
            suppressSizeToFit: true,
        },
    ]

    const [tab_data, settab_data] = useState([])
    useEffect(() => {
        settab_data(Object.keys(data).sort((a, b) => a.user_id > b.user_id ? 1 : -1).reduce((rowData, rowId) => {
            const row = deepClone(data[rowId])
            rowData.push({
                'uniqueId': row.socket_id,
                'user_id': row.user_id,
                'socket_id': row.socket_id,
            })


            return rowData
        }, []))
    }, [data])

    return (
        <Box border="top" margin={{ top: "small", left: "xsmall", right: "xsmall" }} fill="horizontal">
            <Box direction="row">
                <Text margin={{ top: "8px", bottom: "8px" }} size="small" color="dark-3" weight="bold"> Accounts </Text>
            </Box>
            <AgDataTable
                tab_col={tab_col}
                tab_data={tab_data}
                tableName="HealthStatusServiceOptionsApp"
                tableHeight={700}
            />

        </Box>
    )
}

export default HealthStatusServiceOptionsApp